import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'workflow-finx-colorpicker',
  templateUrl: './workflow-finx-colorpicker.component.html',
  styleUrls: ['./workflow-finx-colorpicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkflowFinxColorpickerComponent),
      multi: true,
    },
  ],
})
export class WorkflowFinxColorpickerComponent implements OnInit, ControlValueAccessor {
  private cd = inject(ChangeDetectorRef);

  @Input() selectedColor = '';
  @Output() selectedColorChange = new EventEmitter<string>();
  @Input() formControlName: string;
  @Input() formGroup: FormGroup;
  @Input() cpUseRootViewContainer = false;
  @Input() cpDialogDisplay: 'popup' | 'inline' = 'popup';
  public readonly colorPickerFormControl = new FormControl();
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};

  color: string;

  ngOnInit() {
    this.colorPickerFormControl.valueChanges.subscribe((colorControl) => {
      this.onModelChange(colorControl);
      this.onModelTouched();
      this.selectedColor = colorControl;
      this.color = this.removeSpaceFromColorString(this.selectedColor);
      this.selectedColorChange.emit(colorControl);
    });

    if (this.formControlName && this.formGroup) {
      const formControl = this.formGroup.get(this.formControlName);
      if (formControl) {
        this.colorPickerFormControl.setValue(formControl.value);
        this.selectedColor = formControl.value;
        this.color = this.removeSpaceFromColorString(this.selectedColor);
        formControl.valueChanges.subscribe((value) => {
          this.colorPickerFormControl.setValue(value, { emitEvent: false });
          this.selectedColor = value;
          this.color = this.removeSpaceFromColorString(this.selectedColor);
        });
      }
    }
    this.color = this.removeSpaceFromColorString(this.selectedColor);
  }

  writeValue(value: string): void {
    this.colorPickerFormControl.setValue(value, { emitEvent: false });
    this.selectedColor = value;
    this.color = this.removeSpaceFromColorString(this.selectedColor);
    this.cd.markForCheck();
  }

  registerOnChange(fn: () => void): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onModelTouched = fn;
  }

  public handleColorChange(color: string) {
    this.selectedColor = color;
    this.color = this.removeSpaceFromColorString(this.selectedColor);
    this.onModelChange(color);
    this.selectedColorChange.emit(color);
  }

  private removeSpaceFromColorString(color: string) {
    return color?.split(' ')?.join('');
  }
}
